module.exports = new __parcel__URL__("penguinify.c11c242e.png").toString();